module.exports = __webpack_public_path__ + "static/img/govcard_white_09.613bddf4.svg";